import produce from 'immer';
import {
  CREATE_STRIPE_ACCOUNT_START,
  CREATE_STRIPE_ACCOUNT_SUCCESS,
  CREATE_STRIPE_ACCOUNT_FAILED,
  CREATE_STRIPE_BY_AFFILIATE_START,
  CREATE_STRIPE_BY_AFFILIATE_SUCCESS,
  CREATE_STRIPE_BY_AFFILIATE_FAILED,
} from '../actions/stripe';


const initialState = {
  redirectUrl: '',
  loadingStripe: false,
};


const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case CREATE_STRIPE_ACCOUNT_START: {
      state.loadingStripe = true;
      break;
    }

    case CREATE_STRIPE_ACCOUNT_SUCCESS: {
      const {data} = action;
      state.redirectUrl = data.redirectUrl;
      window.location = data.redirectUrl;

      state.loadingStripe = false;
      break;
    }

    case CREATE_STRIPE_ACCOUNT_FAILED: {
      state.loadingStripe = false;
      break;
    }

    case CREATE_STRIPE_BY_AFFILIATE_START: {
      state.loadingStripe = true;
      break;
    }

    case CREATE_STRIPE_BY_AFFILIATE_SUCCESS: {
      const {data} = action;
      state.redirectUrl = data.redirectUrl;
      window.location = data.redirectUrl;

      state.loadingStripe = false;
      break;
    }

    case CREATE_STRIPE_BY_AFFILIATE_FAILED: {
      state.loadingStripe = false;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
